import { render } from "./PhotoStatsChart.vue?vue&type=template&id=58d9cebc"
import script from "./PhotoStatsChart.vue?vue&type=script&lang=js"
export * from "./PhotoStatsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__